<template>
    <rkm-sidebar :open="open">
        <rkm-sidebar-list>
            <rkm-sidebar-list-group>
                <rkm-sidebar-list-group-item
                    :active="$route.path && $route.path.includes('dashboard')"
                    icon="home"
                    title="Dashboard"
                    to="/"
                />
            </rkm-sidebar-list-group>

            <sidebar-item :items="items" />
        </rkm-sidebar-list>

        <div class="footer">
            <div>ConectaSUS ⋅ {{ others.moment().format('YYYY') }}</div>

            <div>
                <rkm-icon :icon="['far', 'clock']" /> {{ others.moment().format('DD/MM/YYYY HH:mm\\h') }}
            </div>
        </div>
    </rkm-sidebar>
</template>

<script>
// Components.
import SidebarItem from './SidebarItem.vue'

// Others.
import moment from 'moment'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { SidebarItem },
    computed: {
        ...mapGetters(['getMenu']),
        items() {
            return this.getMenu
        },
    },
    data: () => ({
        modulos: [],
        others: { moment },
    }),
    props: {
        open: { type: Boolean },
    },
}
</script>

<style scoped>
.footer {
    background: rgba(0,0,0,0.1);
    border-radius: 100px;
    display: flex;
    flex-direction: column;
    height: 60px;
    justify-content: space-evenly;
    margin: 0.75rem;
    padding: 1rem;
    text-align: center;
}
</style>